import BliModal from '@blibli/blue.modal/dist/modal/blue/Modal'
import BliModalHeader from '@blibli/blue.modal/dist/modal/blue/ModalHeader'
import BliModalBody from '@blibli/blue.modal/dist/modal/blue/ModalBody'
import BliModalFooter from '@blibli/blue.modal/dist/modal/blue/ModalFooter'
import BliButton from '@blibli/blue.button/dist/button/blue/Button'
import BliIconSiPinned from '@blibli/blue-dls-library-icon/dist/Pinned'
import BliIconSiCircleInfo from '@blibli/blue-dls-library-icon/dist/CircleInfo'
import BliIconSiPromotion from '@blibli/blue-dls-library-icon/dist/Promotion'
import CommonMixin from '@vue3/mixins/commonMixin.js'
import BliTabs from '@blibli/blue.tabs/dist/tabs/blue/Tabs'
import BliTab from '@blibli/blue.tabs/dist/tabs/blue/Tab'
import BliLoaderGeneral from '@blibli/blue.loader-general/dist/loader-general/blue/LoaderGeneral'
import emptyState from '@vue3/assets/icons/document-cancel-icon.svg'
import { mapActions, mapState } from 'pinia'
import NotificationStore from '@vue3/store/notification-store.js'
import BliIconSiOpenNew from '@blibli/blue-dls-library-icon/dist/OpenNew'
import RewardsStore from '@vue3/store/rewards-store.js'

export default {
  name: 'NotificationPermissionModal',
  components: {
    BliButton,
    BliModal,
    BliModalHeader,
    BliModalBody,
    BliModalFooter,
    BliIconSiPinned,
    BliIconSiCircleInfo,
    BliIconSiPromotion,
    BliTabs,
    BliTab,
    BliLoaderGeneral,
    BliIconSiOpenNew
  },
  props: {
    isModalVisible: {
      type: Boolean,
      default: false
    },
    isNotificationPage: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      selectedTab: 'ALL',
      tabs: [
        { name: this.$t('notification.tabs.all'), value: 'ALL' },
        { name: this.$t('notification.tabs.info'), value: 'INFO' },
        { name: this.$t('notification.tabs.promo'), value: 'PROMO' }
      ],
      emptyState,
      isNotificationDetailModalVisible: false,
      notificationModalContent: {}
    }
  },
  mixins: [CommonMixin],
  mounted () {
    this.getNotificationsApi()
  },
  watch: {
    selectedTab () {
      this.resetNotificationData()
      this.getNotificationsApi()
    }
  },
  computed: {
    ...mapState(NotificationStore, ['notificationsList', 'isLoadingNotifications', 'currentPage', 'totalRecords']),

    isEmpty () {
      return !this.notificationsList?.length && !this.isLoadingNotifications
    },

    getNotificationIcon () {
      return (notificationType) => {
        switch (notificationType) {
          case 'INFO':
            return 'BliIconSiCircleInfo'
          case 'PROMO':
            return 'BliIconSiPromotion'
          default:
            return 'BliIconSiCircleInfo'
        }
      }
    }
  },
  emits: ['closeModal', 'updateSelectedCompany'],
  methods: {
    ...mapActions(NotificationStore, ['getNotifications', 'markAsRead', 'resetNotificationData']),
    ...mapActions(RewardsStore, ['getEngagementInfo']),
    getNotificationsApi (isLoadMore = false) {
      const query = {
        notificationType: this.selectedTab,
        page: isLoadMore ? this.currentPage + 1 : 0
      }
      this.getNotifications({
        query,
        isLoadMore
      })
    },
    handleNotificationClick (notification) {
      if (!notification.isRead) {
        this.markAsRead({
          data: { notificationId: notification.id },
          success: this.handleNotificationReadSuccess
        })
      }
      this.openModalWithContent(notification)
    },
    handleNotificationReadSuccess () {
      this.getEngagementInfo({
        param: { email: this.userDetails.email }
      })
    },
    openModalWithContent (notification) {
      this.notificationModalContent = {
        title: notification.title,
        description: notification.body,
        link: notification?.link
      }
      this.isNotificationDetailModalVisible = true
    },
    resetNotificationModal () {
      this.notificationModalContent = {}
      this.isNotificationDetailModalVisible = false
    },
    handleScroll ({ target: { scrollTop, clientHeight, scrollHeight } }) {
      const isNearBottom = scrollTop + clientHeight >= scrollHeight - 50
      const hasMoreData = this.notificationsList?.length < this.totalRecords
      const isNotFetching = !this.isLoadingNotifications

      if (isNearBottom && hasMoreData && isNotFetching) {
        this.getNotificationsApi(true)
      }
    },

    formatDate (dateString) {
      if (!dateString) return ''
      const date = new Date(dateString)
      return date.toLocaleDateString('id-ID', {
        day: 'numeric',
        month: 'short',
        year: 'numeric'
      })
    }
  }
}
